import DOMPurify from 'dompurify';

export function sanitize(input: string): string {
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'div', 'span'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });
}
